import {useToasts} from "react-toast-notifications"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {getIncomingAchDownloadable} from "../../resources/incomingAch"
import {downloadFile} from "../../utilities/file"
import React, {useEffect} from "react"
import Button from "../Button/Button"

export function AuditLogDownloadButton({
	auditLogId,
	fileId,
	resourceId,
}: {
	auditLogId?: string
	fileId?: string
	resourceId?: string
}) {
	const accessToken = useAccessToken()
	const [pdfResultState, getPdfRequest] = useAsyncResultIdle(getIncomingAchDownloadable)
	const {addToast} = useToasts()

	const handleDownload = (e: React.MouseEvent) => {
		e.stopPropagation()
		if (auditLogId && fileId) {
			getPdfRequest(accessToken, auditLogId, fileId)
		}
	}

	useEffect(() => {
		pdfResultState.match(
			() => null,
			() => null,
			(json) => {
				downloadFile(`${resourceId}.json`, JSON.stringify(json, null, 2), "application/json")
			},
			() => {
				addToast("Something went wrong", {appearance: "warning"})
			}
		)
	}, [pdfResultState, resourceId, addToast])

	return (
		<Button
			theme="neutral"
			variant="flat"
			prefixIcon="move-snap-down--interface-essential"
			size="small"
			onClick={handleDownload}
		>
			Download
		</Button>
	)
}
